import c from "./OverlayPage.module.scss";

function OverlayPage({ title }) {
	return (
		<div className={c.main_layer}>
			<div className={c.main_session}>
				<div className={c.label}>
					<span className="icon_16 default settings icon_mask !bg-white"></span>
					Compilazione preset: <b>{title}</b>
				</div>
			</div>
		</div>
	);
}

export default OverlayPage;
